// removed by extract-text-webpack-plugin
module.exports = {"contactBoard":"src-styles----contact-module---contactBoard---1tjCP"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/contact.module.scss
// module id = 342
// module chunks = 70144966829960